export enum ShipType {
  OVER_SEA = 0,
  DOMESTIC = 1,
}

export enum PickType {
  SELF_PICK = 0,
  COD = 1,
}

export enum QueryType {
  ALL = '7', // 全部
  TO_CONFIRM = '24', // 待确认
  TO_PICKUP = '23', // 待自提
  TO_DELIVERY = '18', // 待配送
  TO_SHIPPING = '5', // 待发货
  DELIVERYING = '19', // 配送中
  COMPLETED = '20', // 已完成
  CANCELED = '4', // 已作废
  FIRST_LEG_SHIPED = '15', // 头程已发货
  AT_TRANSIT_WAREHOUSE = '16', // 已到中转仓
  OVERSEA_SHIPPING = '17', // 跨境运输中
  RETURNS = '9', // 退换单
  WAREHOUSE_SORTING = '25', // 仓库分拣中
  PURCHASING = '14'
}
